import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import TripsStickyHeader from "../components/Detail/StickyHeader";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getValue } from "@utils/lodash";
import {
  getSpecificTrip,
  getTripValidateApproverFlowType,
  submitTrip,
  uploadTripReceipts,
  deleteTripReceipts,
  recallTrip,
  tripComments,
} from "@services/trips.service";
import TripsTabNavigation from "../../../../components/Trip/tab-navigation";
import { removeNullOrUndefinedProperties } from "@common/text-helpers";
import { toast } from "react-toastify";
import ReportSubmitModal from "@components/Reports/components/ReportSubmitPopup";
import { mediaUpload } from "@services/upload.service";
import { QueryRequestHelper } from "@common/query-request-helper";
import DeleteModal from "@common/popup/DeleteModal";
import CommonApproverFlowPopup from "@common/popup/approver-flow";
import TripsTitleHeader from "@components/Trip/trips-title-header";
import TripsListSection from "@components/Trip/trips-list-section";
import TripsRightSection from "@components/Trip/trips-right-section";
import { getHistory } from "@services/common.service";
import CommonCommentsHistoryPopup from "@common/popup/comment-history-modal";
import Loader from "@components/common/Loader";
import { expenseReportComments } from "@services/expense-reports.service";
import {
  getAllTravelDocumentsAdmin,
  getAllTravelDocumentsUser,
} from "@services/settings.service";
import { useGlobalContext } from "@context/global-context";
import TravelDocumentPopup from "@common/popup/travel-document-modal";
import NoAccessPage from "@components/common/NoAccess";
import TravelDocumentUserPopup from "@common/popup/travel-document-user-modal";
import SubmitConfirmModal from "@common/popup/SubmitConfirmModal";
import SubmitConfirmModalWithComments from "@common/popup/SubmitConfirmModalWithComments";
import RejectDetailsAccordion from "@components/RejectedCommentsSection";
import { useNavigationData } from "@components/common/LeftNavbar/NavigationContext";

function ClientTripsDetail(props: any) {
  let navigate = useNavigate();
  let params = useParams();
  const { user } = useNavigationData();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  let mainQueryRequest = QueryRequestHelper(urlParams);
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [formInfo, setFormInfo] = useState<any>({});
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (Object.keys(urlParams).length === 0 && props.permissionAPITriggered) {
      getData(true);
    }
    getAllHistory();
    getRejectComments();
    getsent_backComments();
    getAwaitingApprovalComments();
    getApproveComments();
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    if (Object.keys(urlParams).length > 0 && props.permissionAPITriggered) {
      getData(true);
    }
  }, [window.location.href, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [activeTab, setActiveTab] = useState("flight");
  const [flightList, setFlightList] = useState([]);
  const [hotelList, setHotelList] = useState([]);
  const [carList, setCarList] = useState([]);
  const [trainList, setTrainList] = useState([]);
  const [busList, setBusList] = useState([]);
  const [tripComment, setTripComment] = useState("");

  const getData = async (status: boolean) => {
    try {
      setIsLoading(status);
      let resp = await getSpecificTrip(getValue(params, `id`, ""));
      if (resp) {
        setDocuments(getValue(resp, `data.documents`, []));
        setFormInfo(getValue(resp, `data`, {}));
        const flightList =
          getValue(resp, `data.itineraries.length`, 0) > 0
            ? getValue(resp, `data.itineraries`, []).filter(
                (item: any) => getValue(item, `travel_mode`, "") === "flight"
              )
            : [];
        const hotelList =
          getValue(resp, `data.itineraries.length`, 0) > 0
            ? getValue(resp, `data.itineraries`, []).filter(
                (item: any) => getValue(item, `travel_mode`, "") === "hotel"
              )
            : [];

        const carList =
          getValue(resp, `data.itineraries.length`, 0) > 0
            ? getValue(resp, `data.itineraries`, []).filter(
                (item: any) => getValue(item, `travel_mode`, "") === "car"
              )
            : [];

        const trainList =
          getValue(resp, `data.itineraries.length`, 0) > 0
            ? getValue(resp, `data.itineraries`, []).filter(
                (item: any) => getValue(item, `travel_mode`, "") === "train"
              )
            : [];

        const busList =
          getValue(resp, `data.itineraries.length`, 0) > 0
            ? getValue(resp, `data.itineraries`, []).filter(
                (item: any) => getValue(item, `travel_mode`, "") === "bus"
              )
            : [];

        setFlightList(flightList);
        setHotelList(hotelList);
        setCarList(carList);
        setTrainList(trainList);
        setBusList(busList);
        setIsLoading(false);

        if (getValue(busList, `length`, 0) > 0) {
          setActiveTab(getValue(busList, `length`, 0) > 0 ? "bus" : "flight");
        }
        if (getValue(trainList, `length`, 0) > 0) {
          setActiveTab(
            getValue(trainList, `length`, 0) > 0 ? "train" : "flight"
          );
        }
        if (getValue(carList, `length`, 0) > 0) {
          setActiveTab(getValue(carList, `length`, 0) > 0 ? "car" : "flight");
        }
        if (getValue(hotelList, `length`, 0) > 0) {
          setActiveTab(
            getValue(hotelList, `length`, 0) > 0 ? "hotel" : "flight"
          );
        }
        if (getValue(flightList, `length`, 0) > 0) {
          setActiveTab(
            getValue(flightList, `length`, 0) > 0 ? "flight" : "flight"
          );
        }
        if (getValue(resp, `data.approval_status`, "") === "rejected") {
          getRejectComments();
        }
        if (getValue(resp, `data.approval_status`, "") === "sent_back") {
          getsent_backComments();
        }
        if (
          getValue(resp, `data.approval_status`, "") === "awaiting_approval"
        ) {
          getAwaitingApprovalComments();
        }
      } else {
        setIsLoading(false);
      }
      getTravelInformation(getValue(resp, `data.created_by.id`, ""));
      if (getValue(resp, `data.travel_type`, "") === "international") {
        getTravelDocumentUser(
          getValue(resp, `data.destination_country.id`, ""),
          getValue(resp, `data.created_by.id`, "")
        );
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const [histoyList, setHistoryList] = useState([]);
  const getAllHistory = async () => {
    try {
      let payload = {
        trip_id: getValue(params, `id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getHistory(queryRequest);
      if (resp) {
        setHistoryList(getValue(resp, `data.approval_history`, []));
      }
    } catch (error) {}
  };

  const handleEdit = () => {
    navigate(`/client/trips/edit/${getValue(params, `id`, "")}`);
  };
  const [showApprovalPopup, setShowApprovalPopup] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                         Travel Document section                            */
  /* -------------------------------------------------------------------------- */
  const [openDocumentUser, setOpenDocumentUser] = useState(false);
  const toggleDocumentUser = () => {
    setOpenDocumentUser(!openDocumentUser);
  };
  const [travelDoucmentsUser, setTravelDocumentsUser] = useState([]);
  const getTravelDocumentUser = async (id: string, user_id: number) => {
    try {
      let payload = {
        country_id: String(id),
        user_id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getAllTravelDocumentsUser(queryRequest);
      if (resp) {
        setTravelDocumentsUser(getValue(resp, `data`, []));
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                         Travel Document section                            */
  /* -------------------------------------------------------------------------- */
  const [openDocument, setOpenDocument] = useState(false);
  const toggleDocument = () => {
    setOpenDocument(!openDocument);
  };
  const [travelDoucments, setTravelDocuments] = useState([]);
  const getTravelInformation = async (id: string) => {
    try {
      let payload = {
        user_id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getAllTravelDocumentsAdmin(queryRequest);
      if (resp) {
        setTravelDocuments(getValue(resp, `data.travel_documents`, []));
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Upload Section                                */
  /* -------------------------------------------------------------------------- */
  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  const [documents, setDocuments] = useState<any>([]);
  const [documentList, setDocumentList] = useState<any>([]);
  const [length, setLength] = useState(0);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadStaticLoading, setUploadStaticLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    if (getValue(params, `id`, "")) {
      let lengthOfUploadedFiles = Array.from(e).length;
      setLength(lengthOfUploadedFiles);
    }
    Array.from(e).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadStaticLoading(true);
        let resp = await mediaUpload(formData);
        if (resp) {
          setDocuments((prevDocuments: any) => [
            ...prevDocuments,
            getValue(resp, `data`, {}),
          ]);
          setDocumentList((prevDocuments: any) => [
            ...prevDocuments,
            getValue(resp, `data`, {}),
          ]);
          if (getValue(params, `id`, "")) {
            setUploadLoading(true);
          }
          e = null;
          setUploadStaticLoading(false);
        } else {
          e = null;
          setUploadStaticLoading(false);
        }
      } catch (error) {
        e = null;
        setUploadStaticLoading(false);
      }
    });
  };
  useEffect(() => {
    if (
      length > 0 &&
      getValue(documentList, `length`, 0) > 0 &&
      getValue(documentList, `length`, 0) === length
    ) {
      uploadFiles();
    } else {
      setLength(0);
    }
  }, [length > 0 && getValue(documentList, `length`, 0) === length]);
  const uploadFiles = async () => {
    try {
      let payload = {};
      let requestPayload: any = payload;
      requestPayload["document_ids"] =
        getValue(documents, `length`, 0) > 0
          ? documents.map((item: object) => getValue(item, `id`, ""))
          : [];
      let resp = await uploadTripReceipts(
        getValue(params, `id`, ""),
        removeNullOrUndefinedProperties(requestPayload)
      );
      if (resp) {
        setUploadLoading(false);
        setLength(0);
        setDocumentList([]);
        toast.success(getValue(resp, `message`, ""));
        getData(false);
      } else {
        setLength(0);
        setDocumentList([]);
        setUploadLoading(false);
      }
    } catch (error) {
      setLength(0);
      setDocumentList([]);
      setUploadLoading(false);
    }
  };
  /* ---------------------------- Delete Document -------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };
  const handleDeleteFunction = async () => {
    try {
      let payload = {
        document_id: deleteId,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await deleteTripReceipts(
        getValue(params, `id`, ""),
        queryRequest
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData(false);
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                             Trip submission Section                        */
  /* -------------------------------------------------------------------------- */

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const [isWorkflowApprover, setIsWorkflowApprover] = useState(false);
  const handleSubmitReport = async () => {
    try {
      let resp = await getTripValidateApproverFlowType(
        getValue(params, `id`, "")
      );
      if (resp) {
        setIsWorkflowApprover(getValue(resp, `data.isWorkflowApprover`, ""));
        if (getValue(resp, `data.isWorkflowApprover`, "")) {
          handleSubmitTrip();
        } else {
          handleModal();
        }
      }
    } catch (error) {}
  };
  const [submitTripLoading, setSubmitTripLoading] = useState(false);
  const [approverId, setApproverId] = useState("");
  const handleSubmitTrip = async () => {
    try {
      setSubmitTripLoading(true);
      let requestPayload: any;

      let submitted_for;
      const submittedBy = getValue(formInfo, `submitted_by`, null);
      const createdBy = getValue(formInfo, `created_by`, null);

      if (submittedBy && createdBy) {
        const createdById = getValue(createdBy, `id`, "");
        if (createdById) {
          submitted_for = Number(createdById);
        }
      }

      if (isWorkflowApprover) {
        requestPayload = {
          id: getValue(params, `id`, ""),
          comments: tripComment,
          submitted_for,
        };
      } else {
        requestPayload = {
          approver_id: approverId,
          id: getValue(params, `id`, ""),
          comments: tripComment,
          submitted_for,
        };
      }

      let resp = await submitTrip(
        removeNullOrUndefinedProperties(requestPayload)
      );

      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData(false);
        setIsOpen(false);
        setSubmitTripLoading(false);
        getAllHistory();
      } else {
        setSubmitTripLoading(false);
      }
    } catch (error) {
      setSubmitTripLoading(false);
    }
  };
  const [recallLoading, setRecallLoading] = useState(false);
  const handleRecall = async () => {
    try {
      setRecallLoading(true);
      let resp = await recallTrip(getValue(params, `id`, ""));
      if (resp) {
        getData(false);
        toast.success(getValue(resp, `message`, ""));
        setRecallLoading(false);
        getAllHistory();
      } else {
        setRecallLoading(false);
      }
    } catch (error) {
      setRecallLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                           Confirm Submit section                           */
  /* -------------------------------------------------------------------------- */
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isConfirmOpenWithComments, setIsConfirmOpenWithComments] =
    useState(false);

  const handleConfirmModal = (status: string) => {
    if (status) {
      setSubmitStatus(status);
    } else {
      setSubmitStatus("");
    }
    setIsConfirmOpen(!isConfirmOpen);
  };

  const handleConfirmModalWithComments = (status: string) => {
    if (status) {
      setSubmitStatus(status);
    } else {
      setSubmitStatus("");
    }
    setIsConfirmOpenWithComments(!isConfirmOpenWithComments);
  };

  const [submitStatus, setSubmitStatus] = useState("");
  const handleConfirmSubmit = () => {
    if (submitStatus === "submit") {
      handleSubmitReport();
      handleConfirmModalWithComments("");
    } else {
      handleRecall();
      handleConfirmModal("");
    }

    setTripComment("");
  };

  /* -------------------------------------------------------------------------- */
  /*                                 History section                            */
  /* -------------------------------------------------------------------------- */
  const [historyOpen, setHistoryOpen] = useState(false);
  const toggleHistory = () => {
    setHistoryOpen(!historyOpen);
  };
  /* -------------------------------------------------------------------------- */
  /*                                  Reject section                            */
  /* -------------------------------------------------------------------------- */
  const [rejectComment, setRejectComment] = useState<any>({});
  const getRejectComments = async () => {
    try {
      let payload = {
        comment_type: "reject",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await tripComments(getValue(params, `id`, ""), queryRequest);
      if (resp) {
        setRejectComment(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };

  const [awaitingApprovalComment, setAwaitingApprovalComment] = useState([]);
  const getAwaitingApprovalComments = async () => {
    try {
      let payload = {
        comment_type: "submit",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await tripComments(getValue(params, `id`, ""), queryRequest);
      if (resp) {
        setAwaitingApprovalComment(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };

  const [sent_backComment, setsent_backComment] = useState([]);
  const getsent_backComments = async () => {
    try {
      let payload = {
        comment_type: "sent_back",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await tripComments(getValue(params, `id`, ""), queryRequest);
      if (resp) {
        setsent_backComment(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };

  const [approveComment, setApproveComment] = useState([]);
  const getApproveComments = async () => {
    try {
      let payload = {
        comment_type: "approve",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await tripComments(getValue(params, `id`, ""), queryRequest);
      if (resp) {
        setApproveComment(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes("trips") ? (
        <NoAccessPage />
      ) : (
        <>
          <TripsStickyHeader
            route={`/client/trips?${mainQueryRequest}`}
            handleEdit={handleEdit}
            formInfo={formInfo}
            handleSubmitTrip={handleConfirmModalWithComments}
            handdleRecall={handleConfirmModal}
            submitTripLoading={submitTripLoading}
            recallLoading={recallLoading}
            toggleHistory={toggleHistory}
            histoyList={histoyList}
            rejectComment={rejectComment}
            permissions={getValue(props, `permissions`, [])}
            sent_backComment={sent_backComment}
            awaitingApprovalComment={awaitingApprovalComment}
            approveComment={approveComment}
          />
          <div className="trips_main_container trips_details_main_container">
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : (
              <>
                <div className="trips_main_container_left">
                  {/* Existing reject comment accordion */}
                  {rejectComment &&
                    Object.entries(rejectComment).length > 0 && (
                      <div className="pt-4">
                        <RejectDetailsAccordion
                          reject={rejectComment}
                          type="rejected"
                        />
                      </div>
                    )}

                  {/* NEW: Add this section for sent_back comments */}
                  {sent_backComment &&
                    Object.entries(sent_backComment).length > 0 && (
                      <div className="pt-4">
                        <RejectDetailsAccordion
                          reject={sent_backComment}
                          type="sent_back"
                        />
                      </div>
                    )}

                  <TripsTitleHeader formInfo={formInfo} />
                  <TripsTabNavigation
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    flightList={flightList}
                    hotelList={hotelList}
                    carList={carList}
                    trainList={trainList}
                    busList={busList}
                  />
                  <TripsListSection
                    activeTab={activeTab}
                    formInfo={formInfo}
                    flightList={flightList}
                    hotelList={hotelList}
                    carList={carList}
                    trainList={trainList}
                    busList={busList}
                  />
                </div>
                <div className="trips_main_container_right">
                  <TripsRightSection
                    formInfo={formInfo}
                    setShowApprovalPopup={setShowApprovalPopup}
                    handleUploadDocuments={handleUploadDocuments}
                    uploadLoading={uploadLoading || uploadStaticLoading}
                    handleDeleteFun={handleDeleteFun}
                    documents={documents}
                    //travel document:
                    showTravelDocument={
                      // getValue(travelDoucments, `length`, 0) > 0 ? true : false
                      false
                    }
                    client={true}
                    toggleDocument={toggleDocument}
                    permissions={getValue(props, `permissions`, [])}
                    getData={getData}
                    // showTravelDocumentUser={}
                    toggleDocumentUser={toggleDocumentUser}
                  />
                </div>
              </>
            )}
          </div>
          <CommonApproverFlowPopup
            showUpdatePopup={showApprovalPopup}
            setShowUpdatePopup={setShowApprovalPopup}
            approvers={getValue(formInfo, `trip_approvers`, [])}
            approvalHistory={histoyList}
          />
          <ReportSubmitModal
            isOpen={isOpen}
            handleModal={handleModal}
            handleSubmit={handleSubmitTrip}
            approverId={approverId}
            setApproverId={setApproverId}
            submitLoading={submitTripLoading}
            setComment={setTripComment}
            comment={tripComment}
          />
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
          <SubmitConfirmModal
            isOpen={isConfirmOpen}
            handleModal={handleConfirmModal}
            handleSubmit={handleConfirmSubmit}
          />

          <SubmitConfirmModalWithComments
            isOpen={isConfirmOpenWithComments}
            handleModal={handleConfirmModalWithComments}
            handleSubmit={handleConfirmSubmit}
            comment={tripComment}
            setComment={setTripComment}
          />
          <CommonCommentsHistoryPopup
            isOpen={historyOpen}
            toggle={toggleHistory}
            list={histoyList}
          />
          <TravelDocumentPopup
            isOpen={openDocument}
            toggle={toggleDocument}
            list={travelDoucments}
          />

          <TravelDocumentUserPopup
            isOpen={openDocumentUser}
            toggle={toggleDocumentUser}
            list={travelDoucmentsUser}
            viewDocuments={user.id === formInfo?.created_by?.id}
          />
        </>
      )}
    </DashboardLayout>
  );
}

export default ClientTripsDetail;
